module.exports = __webpack_public_path__ + "18_hair_gold.0274c366.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/18_hair_gold.png
// module id = 9kyd
// module chunks = 0